var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import compact from 'lodash/compact';
import flatten from 'lodash/flatten';
import { ALL_RECORDS_CQL, buildArrayFieldQuery, buildDateRangeQuery, buildFilterQuery, buildSortingQuery, connectQuery, } from '@folio/stripes-acq-components';
import { CLAIMING_LIST_COLUMNS, FILTERS, ORDER_FORMAT_MATERIAL_TYPE_MAP, } from './constants';
export var CLAIMING_SEARCHABLE_INDICES = [
    'title.title',
    'poLine.titleOrPackage',
    'title.productIds',
    'purchaseOrder.poNumber',
    'poLine.poLineNumber',
    'poLine.vendorDetail.referenceNumbers',
];
export var getKeywordQuery = function (query) { return CLAIMING_SEARCHABLE_INDICES.reduce(function (acc, sIndex) {
    if (acc) {
        return "".concat(acc, " or ").concat(sIndex, "==\"*").concat(query, "*\"");
    }
    else {
        return "".concat(sIndex, "==\"*").concat(query, "*\"");
    }
}, ''); };
export var buildClaimingQuery = function (activeFilters, sorting) {
    var _a, _b;
    var filters = __assign({}, activeFilters);
    var materialTypeFilterQuery;
    var materialType = filters[FILTERS.MATERIAL_TYPE];
    var orderFormat = filters[FILTERS.ORDER_FORMAT];
    if (materialType && orderFormat) {
        materialTypeFilterQuery = flatten([orderFormat]).map(function (format) {
            var orderFormatQuery = "poLine.orderFormat==\"".concat(format, "\"");
            var materialTypeQuery = ORDER_FORMAT_MATERIAL_TYPE_MAP[format]
                .map(function (materialTypeCql) { return "".concat(materialTypeCql, "==\"").concat(materialType, "\""); })
                .join(' or ');
            return "(".concat(orderFormatQuery, " and (").concat(materialTypeQuery, "))");
        }).join(' or ');
        materialTypeFilterQuery = "(".concat(materialTypeFilterQuery, ")");
    }
    else if (materialType) {
        materialTypeFilterQuery = "(poLine.eresource.materialType==\"".concat(materialType, "\" or poLine.physical.materialType==\"").concat(materialType, "\")");
    }
    if (materialTypeFilterQuery) {
        filters[FILTERS.MATERIAL_TYPE] = undefined;
        filters[FILTERS.ORDER_FORMAT] = undefined;
    }
    var filtersFilterQuery = buildFilterQuery(filters, function (query, qindex) {
        if (qindex) {
            return "(".concat(qindex, "==*").concat(query, "*)");
        }
        return getKeywordQuery(query);
    }, (_a = {},
        _a[FILTERS.TITLE_DATE_CREATED] = buildDateRangeQuery.bind(null, [FILTERS.TITLE_DATE_CREATED]),
        _a[FILTERS.TITLE_DATE_UPDATED] = buildDateRangeQuery.bind(null, [FILTERS.TITLE_DATE_UPDATED]),
        _a[FILTERS.PIECE_DATE_CREATED] = buildDateRangeQuery.bind(null, [FILTERS.PIECE_DATE_CREATED]),
        _a[FILTERS.PIECE_DATE_UPDATED] = buildDateRangeQuery.bind(null, [FILTERS.PIECE_DATE_UPDATED]),
        _a[FILTERS.EXPECTED_RECEIPT_DATE] = buildDateRangeQuery.bind(null, [FILTERS.EXPECTED_RECEIPT_DATE]),
        _a[FILTERS.RECEIVED_DATE] = buildDateRangeQuery.bind(null, [FILTERS.RECEIVED_DATE]),
        _a[FILTERS.RECEIPT_DUE] = buildDateRangeQuery.bind(null, [FILTERS.RECEIPT_DUE]),
        _a[FILTERS.LOCATION] = function (filterValue) { return "(".concat([FILTERS.LOCATION, 'poLine.searchLocationIds']
            .map(function (filterKey) { return buildArrayFieldQuery(filterKey, filterValue); })
            .join(' or '), ")"); },
        _a[FILTERS.POL_TAGS] = buildArrayFieldQuery.bind(null, [FILTERS.POL_TAGS]),
        _a[FILTERS.ACQUISITIONS_UNIT] = buildArrayFieldQuery.bind(null, [FILTERS.ACQUISITIONS_UNIT]),
        _a));
    var filterQuery = compact([filtersFilterQuery, materialTypeFilterQuery]).join(' and ') || ALL_RECORDS_CQL;
    var sortingQuery = buildSortingQuery(sorting, (_b = {},
        _b[CLAIMING_LIST_COLUMNS.receiptDate] = ["piece.".concat(CLAIMING_LIST_COLUMNS.receiptDate)],
        _b[CLAIMING_LIST_COLUMNS.receivingStatus] = ["piece.".concat(CLAIMING_LIST_COLUMNS.receivingStatus)],
        _b[CLAIMING_LIST_COLUMNS.displaySummary] = ["piece.".concat(CLAIMING_LIST_COLUMNS.displaySummary)],
        _b[CLAIMING_LIST_COLUMNS.chronology] = ["piece.".concat(CLAIMING_LIST_COLUMNS.chronology)],
        _b[CLAIMING_LIST_COLUMNS.enumeration] = ["piece.".concat(CLAIMING_LIST_COLUMNS.enumeration)],
        _b[CLAIMING_LIST_COLUMNS.title] = ["title.".concat(CLAIMING_LIST_COLUMNS.title)],
        _b)) || 'sortby piece.receiptDate/sort.ascending';
    return connectQuery(filterQuery, sortingQuery);
};
